import { useEffect, useState } from "react";
import { Alert, Button, Snackbar } from "@mui/material";
import { useDataCompleteness } from "@/context/DataCompletenessContext";

const SHOWN_KEY = "dataCompletenessReminderShown";

function alreadyShown(): boolean {
  try {
    return sessionStorage.getItem(SHOWN_KEY) === "1";
  } catch {
    return false;
  }
}

function markShown() {
  try {
    sessionStorage.setItem(SHOWN_KEY, "1");
  } catch {
    // Storage blocked: the reminder may show again on the next load.
  }
}

/** Once per browser session, tells a user with missing data and offers the list. */
export function DataCompletenessReminder() {
  const { outstanding, openDialog } = useDataCompleteness();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (outstanding > 0 && !alreadyShown()) {
      markShown();
      setOpen(true);
    }
  }, [outstanding]);

  return (
    <Snackbar
      open={open}
      autoHideDuration={15_000}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      onClose={(_event, reason) => {
        if (reason !== "clickaway") setOpen(false);
      }}
    >
      <Alert
        severity="error"
        variant="filled"
        onClose={() => setOpen(false)}
        action={
          <Button
            color="inherit"
            size="small"
            onClick={() => {
              setOpen(false);
              openDialog();
            }}
          >
            Review
          </Button>
        }
      >
        {outstanding} {outstanding === 1 ? "deal you lead needs" : "deals you lead need"}{" "}
        data filled in.
      </Alert>
    </Snackbar>
  );
}
